import React, { Component } from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Select from "react-select";
import axios from "axios";
import Cookies from "js-cookie";
import settings from "../../helpers/Settings";
import AddCompany from "./addCompany";
import Modal from '@mui/material/Modal';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Icon } from "@iconify/react";
import { IconButton } from '@mui/material';
import MoreOptions from "./MoreOptions";
import { FormControl } from '@mui/material';
import AddEmployee from "./AddEmployee";
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import SELECT from '@mui/material/Select';
import DepartmentManagment from "./AddDepartment";
let { KayanURL } = settings;
const styleModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  borderRadius: '20px',
  p: 4,
};
class UserManagment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      items: [],
      addNewCompanyPopUp: false,
      allCompanies: [],
      selectedCompanyEmployees: [],
      displayCompanyInfo: false,
      openEmployeePopUp: false,
      activebtn: false,
      addLicensetotable: false,
      licenseDuplicate: false,
      licenseValue: false,
      removeLicenseInputValue: false,
      displayCompanyAfterUpdate: false,
      updateNameOfEmployee: false,
      updateUserNameOfEmployee: false,
      role: "doctor"
    };
  }
  componentDidMount = async (e) => {
    this.getAllCompany();
  };
  getAllDepartments = async () => {
    let AllDepartments = await axios.put(
      KayanURL + "api/KSA/RCM/admin/getAllDepartment",
      {
        apiToken: Cookies.get("RCM_KSA_Admin_Token")
      }
    );
    if (AllDepartments) {
      let { data } = AllDepartments;
      if (data) {
        if (data.success) {
          this.setState({ success: true, allDepartments: data.data.departments });
          if (data.data.departments && data.data.departments.length > 0) {
            console.log(data.data.departments)
            const departmentRows = data.data.departments.map((element, index) => {
              console.log(element)
              return (
                <MenuItem key={index} value={element.id} style={{ fontSize: "small" }}>{element.name}</MenuItem>
              )
            })
            console.log(departmentRows)
            this.setState({ departmentRows })
          }
        } else {
          this.setState({ success: false, error: data.error, allDepartments: data.data.departments });
        }
      }
    }
  };
  getAllCompany = async (e) => {
    const result = await axios.put(
      KayanURL + "api/KSA/RCM/admin/getAllCompany",
      {
        apiToken: Cookies.get("RCM_KSA_Admin_Token"),
      }
    ); //try

    if (result) {
      let { data } = result;
      let options = [];
      if (data && data.success) {
        let { company } = data.data;
        this.setState({
          allCompanies: data.data.company,
          displayCompany: false,
        });
        if (this.state.displayCompanyAfterUpdate) {
          let selectedCompany = company.filter((com) => {
            return com.id == this.state.selectedCompanyID;
          });
          this.setState({
            displayCompany: true,
            selectedCompany: selectedCompany[0]
          });
        }
        if (company && company.length > 0) {
          for (let i = 0; i < company.length; i++) {
            options.push({
              value: company[i].id,
              label: company[i].name,
            });
          }
          this.setState({ options });
        } else {
          this.setState({ msgCompany: "There is No Company!" });
        }
      }
    }
  };
  onSelectValue = async (e) => {
    this.setState({
      selectedCompanyID: e.value,
      AllDoctors: [],
      AllFinancial: [],
      AllReceptionist: [],
      allDoctors: null,
      allReceptionists: null,
      allFinancials: null
    });

    let allCompanies = this.state.allCompanies;
    let selectedCompany = allCompanies.filter((com) => {
      return com.id == e.value;
    });

    if (selectedCompany && selectedCompany.length > 0) {
      console.log(selectedCompany, "company")
      this.setState({
        selectedCompany: selectedCompany[0],
        displayCompany: true,

      });
    }
    this.setState({ displayCompanyInfo: true, });
  };
  handleDeleteCompany = async (index) => {
    this.setState({
      deleteCompanyRequestSent: true,
      deleteCompanyResponse: false,
    });
    let response = await axios.put(
      KayanURL + "api/KSA/RCM/admin/deleteCompany",
      {
        id: index,
        apiToken: Cookies.get("RCM_KSA_Admin_Token"),
      }
    );

    if (response) {
      this.setState({
        deleteCompanyResponse: true,
        deleteCompanyRequestSent: false,
      });
      let { data } = response;
      if (data.success) {
        this.setState({ deleteCompanySelected: false });
        // window.location.reload(true);
        this.getAllCompany();
      } else {
        let { error } = data;
        if (error) {
          this.setState({ deleteCompanyError: error });
        }
      }
    }
  };
  handleUpdateCompany = async (index) => {
    this.setState({
      updateCompanyPopup: true
    })
    let { allCompanies } = this.state;
    let selectedCompany = allCompanies.filter((p) => {
      return p.id == index;
    });
    if (selectedCompany && selectedCompany.length > 0) {
      selectedCompany = selectedCompany[0];
      this.setState({
        id: selectedCompany.id,
        name: selectedCompany.name,
        username: selectedCompany.username,
        transactions: selectedCompany.transactions,
      })
    }

  }
  updateCompanyHandleInputTextChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  UpdateCompany = async (e) => {
    e.preventDefault();
    const result = await axios.put(KayanURL + "api/KSA/RCM/admin/updateCompany", {
      id: this.state.id,
      name: this.state.name,
      username: this.state.username,
      transactions: this.state.transactions,
      activationperiod: this.state.activationperiod,
      password:this.state.password?this.state.password:"",
      apiToken: Cookies.get("RCM_KSA_Admin_Token"),

      headers: {
        "Content-Type": "application/json",
      },
    });
    if (result.data.success) {
      this.setState({
        updatemessage: "updated Successfully !!!!",
        displayCompanyAfterUpdate: true,
        updateCompanyPopup: false,
        password:""
      });
      this.getAllCompany();
    } else {
      this.setState({
        updatemessage: "Not updated,Please enter correct data!",
      });
    }
  };
  openAddNewCompanyModal = () => {
    this.setState({ openAddCompanyModal: true })
  }
  closeAddNewCompanyModal = () => {
    this.setState({ openAddCompanyModal: false })
    this.getAllCompany();
  }
  closeUpdateCompanyModal = () => {
    this.setState({ updateCompanyPopup: false, updatemessage: "" })
  }
  closeAddNewEmployeeModal = () => {
    this.setState({ openEmployeePopUp: false })

  }
  getAllDoctors = async (companyId, role) => {
    const result = await axios.put(
      KayanURL + "api/KSA/RCM/employee/getAllDoctors",
      {
        companyId: companyId,
        role: role,
        apiToken: Cookies.get("RCM_KSA_Admin_Token"),
      }
    );

    if (result) {
      let { data } = result;
      if (data && data.success) {
        this.setState({ AllDoctors: data.doctors });
      } else {
        this.setState({ AllDoctors: data.doctors });
      }
    }
  };
  handleDeleteDoctor = async (index) => {
    let response = await axios.put(
      KayanURL + "api/KSA/RCM/employee/deleteDoctor",
      {
        id: index,
        apiToken: Cookies.get("RCM_KSA_Admin_Token"),
      }
    );
    if (response) {
      let { data } = response;
      if (data.success) {
        this.setState({ success: "true" });
        this.getAllDoctors(this.state.selectedCompany.id);
      } else {
        let { error } = data;
        if (error) {
          this.setState({ success: false, deleteDoctorError: error });
        }
      }
    }
  };
  handleUpdateDoctor = async (index) => {
    this.getAllDoctors(this.state.selectedCompany.id, this.state.role);
    let { AllDoctors } = this.state;
    let doctorJsonValueForUpdate
    let selectedDoctor = AllDoctors.filter((p) => {
      return p.id == index;
    });
    if (selectedDoctor && selectedDoctor.length > 0) {
      selectedDoctor = selectedDoctor[0];
      if (selectedDoctor.role == "doctor") {
        doctorJsonValueForUpdate = {
          id: selectedDoctor.id,
          name: selectedDoctor.name,
          username: selectedDoctor.username,
          license: selectedDoctor.doctor_license,
          practiceCode: selectedDoctor.doctor_practice_code
        }

      }
      else {
        doctorJsonValueForUpdate = {
          id: selectedDoctor.id,
          name: selectedDoctor.name,
          username: selectedDoctor.username,
        }
      }

      this.setState({ doctorJsonValueForUpdate, updateDoctorModal: true });
    }
  }
  closeUpdateDoctorModal = () => {
    this.setState({ updateDoctorModal: false })
    this.getAllDoctors(this.state.selectedCompany.id, this.state.role)
  }
  updateDoctorHandleInputTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name === 'name') {
      this.state.doctorJsonValueForUpdate.name = value;
    } else if (name === 'license') {
      this.state.doctorJsonValueForUpdate.license = value;
    } else if (name === 'username') {
      this.state.doctorJsonValueForUpdate.username = value;
    } else if (name === 'practiceCode') {
      this.state.doctorJsonValueForUpdate.practiceCode = value;
    }else if(name === "employeePassword"){
      this.setState({employeePassword :value})
    }

  };
  UpdateDoctor = async (e) => {
    e.preventDefault();
    const result = await axios.put(KayanURL + "api/KSA/RCM/employee/updateDoctor", {
      id: this.state.doctorJsonValueForUpdate.id,
      name: this.state.doctorJsonValueForUpdate.name,
      username: this.state.doctorJsonValueForUpdate.username,
      license: this.state.role === "doctor" ? this.state.doctorJsonValueForUpdate.license : "",
      practiceCode: this.state.role === "doctor" ? this.state.doctorJsonValueForUpdate.practiceCode : "",
      password:this.state.employeePassword ? this.state.employeePassword : "",
      apiToken: Cookies.get("RCM_KSA_Admin_Token"),

      headers: {
        "Content-Type": "application/json",
      },
    });
    if (result.data.success) {
      this.setState({
        updatemessage: "updated Successfully !!!!",
        updateDoctorModal: false,
        employeePassword: ""
      });
      this.getAllDoctors(this.state.selectedCompany.id, this.state.role);
    } else {
      this.setState({
        updatemessage: "Not updated,Please enter correct data!",
      });
    }
  };
  handleChangeRadioButton = (e) => {
    let value = e.target.value;
    this.setState({ role: e.target.value })
    this.getAllDoctors(this.state.selectedCompany.id, value)

  }
  render() {
    let { selectedCompany, AllDoctors } = this.state;
    let companyInfoRow, doctorRows
    if (selectedCompany) {
      companyInfoRow = (
        <TableRow
        >
          <TableCell align="center" style={{ fontSize: "small" }}>{selectedCompany.name}</TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>{selectedCompany.nphies_id}</TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>{selectedCompany.nphies_provider_name}</TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>{selectedCompany.username}</TableCell>
          {selectedCompany.active ? <TableCell align="center" style={{ fontSize: "small" }}>Active</TableCell> : <TableCell align="center" style={{ fontSize: "small" }}>Not Active</TableCell>}
          <TableCell align="center" style={{ fontSize: "small" }}>{selectedCompany.endedat}</TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>{selectedCompany.transactions}</TableCell>

          <TableCell align="center" style={{ fontSize: "small" }}>
            <MoreOptions
              handleDelete={() => this.handleDeleteCompany(selectedCompany.id)}
              handleUpdate={() => this.handleUpdateCompany(selectedCompany.id)}
            />
          </TableCell>
        </TableRow>
      );
    }
    if (AllDoctors && AllDoctors.length > 0) {
      doctorRows = AllDoctors.map((element, index) => {
        return (
          <TableRow key={index}
          >
            {this.state.role === "doctor" ? (<>
              <TableCell align="center" style={{ fontSize: "small" }}>{element.name}</TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>{element.username}</TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>{element.doctor_license}</TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>{element.doctor_practice_code}</TableCell>
            </>) : (<>
              <TableCell align="center" style={{ fontSize: "small" }}>{element.name}</TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>{element.username}</TableCell>
            </>)}

            <TableCell align="center" style={{ fontSize: "small" }}>
              <MoreOptions
                handleDelete={() => this.handleDeleteDoctor(element.id)}
                handleUpdate={() => this.handleUpdateDoctor(element.id)}
              />
            </TableCell>
          </TableRow>
        )
      })
    }
    return (
      <>
        <Box height={60} />
        <div
          style={{
            textAlign: "left",
            boxShadow: "1px solid grey",
            padding: "15px",
            boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
            borderRadius: "10px"
          }}>
          <div
            style={{
              boxShadow: "1px solid grey",
              padding: "15px",
              boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
              borderRadius: "10px", width: "30%", margin: "auto"
            }}>
            <Select
              onChange={(e) => this.onSelectValue(e)}
              options={this.state.options}
              isSearchable="true"
            ></Select>
            <div style={{ textAlign: "center" }}>
              <a
                onClick={(e) => this.openAddNewCompanyModal(e)}
                style={{
                  color: "grey",
                  display: "inline-block",
                  marginTop: "5px",
                  fontWeight: "550",
                  textDecorationLine: "underline",
                  cursor: "pointer"
                }}
              >
                Add New Company
              </a>
            </div>
          </div>

          {this.state.openAddCompanyModal ? (
            <>
              <Modal
                open={this.state.openAddCompanyModal}
                onClose={this.closeAddNewCompanyModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ overflowY: "scroll" }}
              >
                <Box sx={styleModal} style={{
                  width: "50%",
                  height: "550px",
                  border: "1px solid white",
                }}>
                  <AddCompany closeAddNewCompanyModal={this.closeAddNewCompanyModal} />

                </Box>
              </Modal>
            </>
          ) : null}
          {this.state.selectedCompanyID && selectedCompany && this.state.displayCompany ? (
            <div style={{ width: "90%", margin: "30px auto" }}>

              <TableContainer component={Paper} style={{ marginTop: "10px", width: "100%" }}>
                <Table aria-label="simple table">
                  <TableHead style={{ backgroundColor: "#fafafa" }}>
                    <TableRow style={{ textAlign: 'center' }}>
                      <TableCell align="center">Company Name</TableCell>
                      <TableCell align="center">Nphies Provider ID</TableCell>
                      <TableCell align="center">Nphies Provider Name</TableCell>
                      <TableCell align="center">User Name</TableCell>
                      <TableCell align="center">Active Status</TableCell>
                      <TableCell align="center">Activation End Date</TableCell>
                      <TableCell align="center">Transactions</TableCell>
                      <TableCell align="center">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {companyInfoRow}
                  </TableBody>
                </Table>
              </TableContainer>

              <div style={{ width: "22%", marginTop: "17px", marginRight: "auto" }}>
                <Button variant="primary" type="submit"
                  onClick={() =>
                    this.setState({
                      openEmployeePopUp: true,
                    })
                  }
                  style={{
                    width: "100%",
                    padding: "6px",
                    backgroundColor: "rgb(97 110 120"
                    , border: "1px solid rgb(97 110 120", color: "white"
                  }}>
                  Add New Employee
                </Button>
              </div>
              <div>
                <div style={{ textAlign: "center" }}>
                  <Typography variant="h6" component="div" >
                     Employees For {selectedCompany.name} Company:
                  </Typography>
                </div>
                <div style={{ width: "60%", margin: "10px auto", textAlign: "center" }}>
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="radio-buttons-group"
                      onChange={this.handleChangeRadioButton}
                    >
                      <div
                        style={{ display: "flex" }}
                      >
                        <FormControlLabel value="doctor" control={<Radio />} label="Doctors" />
                        <FormControlLabel value="receptionist" control={<Radio />} label="Receptionists" />
                        <FormControlLabel value="financial" control={<Radio />} label="Financials" />
                        <FormControlLabel value="nurse" control={<Radio />} label="Nurses" />
                        <FormControlLabel value="super" control={<Radio />} label="Super" />
                      </div>

                    </RadioGroup>
                  </FormControl>
                </div>
              </div>

              {this.state.AllDoctors && this.state.AllDoctors.length > 0 ? (<>
                <div style={{ width: "70%", margin: "30px auto" }}>
                  <TableContainer component={Paper} style={{ marginTop: "10px", width: "100%" }}>
                    <Table aria-label="simple table">
                      <TableHead style={{ backgroundColor: "#fafafa" }}>
                        <TableRow style={{ textAlign: 'center' }}>
                          {this.state.role == "doctor" ? (<>
                            <TableCell align="center">Name</TableCell>
                            <TableCell align="center">User Name</TableCell>
                            <TableCell align="center">License</TableCell>
                            <TableCell align="center">Practice Code</TableCell>
                            <TableCell align="center">Actions</TableCell>
                          </>) : (<>
                            <TableCell align="center">Name</TableCell>
                            <TableCell align="center">User Name</TableCell>
                            <TableCell align="center">Actions</TableCell>
                          </>)}

                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {doctorRows}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </>) : null}


            </div>
          ) : null}

          {this.state.updateCompanyPopup ? (
            <>
              <Modal
                open={this.state.updateCompanyPopup}
                onClose={this.closeUpdateCompanyModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ overflowY: "scroll" }}
              >
                <Box sx={styleModal} style={{
                  width: "30%",
                  height: "300px",
                  overflowY: "scroll",
                  border: "1px solid white",
                }}>
                  <FormControl fullWidth sx={{ mb: 3 }} >
                    <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                      inputProps={{ sx: { padding: "11px" } }} required
                      label="Company Name" variant="outlined"
                      name="name"
                      onChange={this.updateCompanyHandleInputTextChange}
                      defaultValue={this.state.name ? this.state.name : ""}
                    />
                  </FormControl>
                  <FormControl fullWidth sx={{ mb: 3 }}>
                    <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                      inputProps={{ sx: { padding: "11px" } }}
                      required name="username" label="User Name"
                      variant="outlined" onChange={this.updateCompanyHandleInputTextChange}
                      defaultValue={this.state.username ? this.state.username : ""}

                    />
                  </FormControl>
                  <FormControl fullWidth sx={{ mb: 3 }}>
                    <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                      inputProps={{ sx: { padding: "11px" } }}
                      required name="transactions"
                      type="number" label="Transactions"
                      variant="outlined" onChange={this.updateCompanyHandleInputTextChange}
                      defaultValue={this.state.transactions ? this.state.transactions : ""}
                    />
                  </FormControl>
                  <FormControl fullWidth sx={{ mb: 3 }}>
                    <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                      inputProps={{ sx: { padding: "11px" } }}
                      required name="password"
                      type="password" label="Password"
                      variant="outlined" onChange={this.updateCompanyHandleInputTextChange}
                    />
                  </FormControl>

                  <div style={{ textAlign: "center" }}>
                    <Button variant="primary" type="submit"
                      onClick={(e) => this.UpdateCompany(e)}
                      style={{
                        width: "50%"
                        , marginTop: "10px"
                        , backgroundColor: "rgb(97 110 120"
                        , border: "1px solid rgb(97 110 120", color: "white"
                      }}>
                      Update
                    </Button>
                  </div>

                </Box>
              </Modal>
            </>
          ) : null}
          {this.state.openEmployeePopUp ? (
            <>
              <Modal
                open={this.state.openEmployeePopUp}
                onClose={this.closeAddNewEmployeeModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ overflowY: "scroll" }}
              >
                <Box sx={styleModal} style={{
                  width: "60%",
                  height: "470px",
                  overflowY: "scroll",
                  border: "1px solid white",
                }}>
                  <AddEmployee
                    companyId={selectedCompany.id}
                  // closeAddNewCompanyModal={this.closeAddNewCompanyModal}
                  />
                </Box>
              </Modal>
            </>
          ) : null}
          {this.state.updateDoctorModal ? (
            <>
              <Modal
                open={this.state.updateDoctorModal}
                onClose={this.closeUpdateDoctorModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ overflowY: "scroll" }}
              >
                <Box sx={styleModal} style={{
                  width: "30%",
                  height: "300px",
                  overflowY: "scroll",
                  border: "1px solid white",
                }}>
                  <FormControl fullWidth sx={{ mb: 3 }} >
                    <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                      inputProps={{ sx: { padding: "11px" } }} required
                      label="Name" variant="outlined"
                      name="name"
                      onChange={this.updateDoctorHandleInputTextChange}
                      defaultValue={this.state.doctorJsonValueForUpdate.name ? this.state.doctorJsonValueForUpdate.name : ""}
                    />
                  </FormControl>
                  <FormControl fullWidth sx={{ mb: 3 }}>
                    <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                      inputProps={{ sx: { padding: "11px" } }}
                      required name="username" label="User Name"
                      variant="outlined" onChange={this.updateDoctorHandleInputTextChange}
                      defaultValue={this.state.doctorJsonValueForUpdate.username ? this.state.doctorJsonValueForUpdate.username : ""}
                    />
                  </FormControl>
                  {this.state.role === "doctor" ? (<>
                    <FormControl fullWidth sx={{ mb: 3 }}>
                      <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                        inputProps={{ sx: { padding: "11px" } }}
                        required name="license" label="License"
                        variant="outlined" onChange={this.updateDoctorHandleInputTextChange}
                        defaultValue={this.state.doctorJsonValueForUpdate.license ? this.state.doctorJsonValueForUpdate.license : ""}
                      />
                    </FormControl>
                    <FormControl fullWidth sx={{ mb: 3 }}>
                      <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                        inputProps={{ sx: { padding: "11px" } }}
                        required name="practiceCode" label="Practice Code"
                        variant="outlined" onChange={this.updateDoctorHandleInputTextChange}
                        defaultValue={this.state.doctorJsonValueForUpdate.practiceCode ? this.state.doctorJsonValueForUpdate.practiceCode : ""}
                      />
                    </FormControl>
                  </>) : null}
                  <FormControl fullWidth sx={{ mb: 3 }}>
                    <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                      inputProps={{ sx: { padding: "11px" } }}
                      required name="employeePassword"
                      type="password" label="Password"
                      variant="outlined" onChange={this.updateDoctorHandleInputTextChange}
                    />
                  </FormControl>

                  <div style={{ textAlign: "center" }}>
                    <Button variant="primary" type="submit"
                      onClick={(e) => this.UpdateDoctor(e)}
                      style={{
                        width: "50%"
                        , marginTop: "10px"
                        , backgroundColor: "rgb(97 110 120"
                        , border: "1px solid rgb(97 110 120", color: "white"
                      }}>
                      Update
                    </Button>
                  </div>
                </Box>
              </Modal>
            </>
          ) : null}

        </div>
      </>

    );
  }

}
export default UserManagment;
